export default __webpack_public_path__ + "static/media/389.8bd78f10.png";